import { Mail, MapPin, Clock } from 'lucide-react';
import brandConfig from '../../config/brandConfig';

const ContactSection = () => {
  const emailContact = brandConfig.emailContact;

  const contactInfo = [
    { icon: <Mail className="w-5 h-5" />, title: "Email", content: emailContact, link: `mailto:${emailContact}` },
    { icon: <MapPin className="w-5 h-5" />, title: "Ubicacion", content: "Lima, Peru", link: null }
  ];

  return (
    <section id="contact" className="py-24 lg:py-32 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-bold uppercase tracking-[0.2em] mb-3" style={{ color: brandConfig.primaryColor }}>
            Hablemos
          </p>
          <h2 className="text-4xl lg:text-6xl font-extrabold text-gray-900 dark:text-white mb-6 tracking-tight">
            Contactanos
          </h2>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
            Tienes alguna pregunta? Estamos aqui para ayudarte.
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-6">
          {/* WhatsApp CTA */}
          <a
            href="https://chat.whatsapp.com/IMt2UZnUc4f8x8ZkD3jkkz"
            target="_blank"
            rel="noopener noreferrer"
            className="group block bg-gradient-to-br from-emerald-500 to-green-600 rounded-3xl p-8 shadow-xl shadow-green-500/10 hover:shadow-green-500/20 transition-all duration-300 hover:scale-[1.01]"
          >
            <div className="flex flex-col sm:flex-row items-center gap-5 text-white">
              <div className="flex-shrink-0 w-14 h-14 bg-white/15 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div className="text-center sm:text-left flex-1">
                <p className="text-xs font-bold uppercase tracking-wider text-green-200 mb-1">Grupo de WhatsApp</p>
                <p className="text-xl font-extrabold">Unete a nuestra comunidad</p>
                <p className="text-sm text-green-100/80 mt-1">Conecta con otros usuarios, recibe tips y novedades</p>
              </div>
              <div className="flex-shrink-0 w-10 h-10 bg-white/15 rounded-full flex items-center justify-center group-hover:bg-white/25 transition-colors">
                <svg className="w-5 h-5 text-white group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </div>
            </div>
          </a>

          {/* Contact Info */}
          <div className="bg-gray-50 dark:bg-gray-800/50 rounded-3xl p-8 border border-gray-100 dark:border-gray-800">
            <h3 className="text-xl font-extrabold text-gray-900 dark:text-white mb-6 text-center tracking-tight">
              Informacion de Contacto
            </h3>
            <div className="space-y-5">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-white dark:bg-gray-700 rounded-xl flex items-center justify-center shadow-sm">
                    <div style={{ color: brandConfig.primaryColor }}>{info.icon}</div>
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">{info.title}</p>
                    {info.link ? (
                      <a href={info.link} className="font-semibold text-gray-900 dark:text-white hover:text-orange-600 dark:hover:text-orange-400 transition-colors">
                        {info.content}
                      </a>
                    ) : (
                      <p className="font-semibold text-gray-900 dark:text-white">{info.content}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Office Hours */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 dark:from-orange-950/20 dark:to-amber-950/10 rounded-3xl p-8 border border-orange-100 dark:border-orange-900/30">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-5 h-5" style={{ color: brandConfig.primaryColor }} />
              <h3 className="text-lg font-extrabold text-gray-900 dark:text-white tracking-tight">
                Horario de Atencion
              </h3>
            </div>
            <div className="space-y-2 text-sm">
              <p className="font-semibold text-gray-700 dark:text-gray-300">Lunes - Viernes: 9:00 AM - 6:00 PM (GMT-5)</p>
              <p className="font-semibold text-gray-700 dark:text-gray-300">Sabados: 9:00 AM - 1:00 PM (GMT-5)</p>
              <p className="text-gray-400 dark:text-gray-500">Domingos: Cerrado</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
